import { useMutation, useQueryClient } from "@tanstack/react-query";
import { applyNewSession } from "@/features/identity/apply-new-session";
import {
  completeSignup,
  requestSignupToken,
  verifySignupToken,
} from "@/features/identity/identity.api";
import {
  markRegistrationCompleted,
  type RegistrationMethod,
} from "@/shared/analytics/registration-analytics";

export function useRequestSignupToken() {
  return useMutation({
    mutationFn: requestSignupToken,
  });
}

export function useVerifySignupToken() {
  return useMutation({
    mutationFn: verifySignupToken,
  });
}

export function useCompleteSignup(method: RegistrationMethod) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: completeSignup,
    onSuccess: async () => {
      markRegistrationCompleted(method);
      // New session, refresh /auth/me and drop any prior identity's cache.
      await applyNewSession(queryClient);
    },
  });
}
